import * as CONSTANTS from '../constants/constants';
export const uploadMedia = (media) => (
    dispatch,
    getState,
    { getFirebase, getFirestore }
  ) => {
  const firestore = getFirestore();
  const mediaRef = firestore.collection('media')
  mediaRef.add(media).then((qs)=>{
      console.log("Media added successfully")
  })
  }

  export const getMedia = uid => (
    dispatch,
    getState,
    { getFirestore }
  ) => {

    const firestore = getFirestore();
    const mediaRef = firestore.collection('media').where("uid","==",uid);
    mediaRef.get().then((snapshot) => {
    var media =[]
      snapshot.forEach((doc)=>{
        media.push(Object.assign(doc.data(), { id: doc.id }))
      })
      dispatch({ type: CONSTANTS.GET_MEDIA, media });
    }).catch((e) => {
      console.log('error', e);
    });
  };